"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _SelectFormFieldWithQuantity = require("./SelectFormFieldWithQuantity.styles");
var _Text = require("../Text");
var _Tooltip = require("../Tooltip");
var _lib = require("../../lib");
var _styledComponents = require("styled-components");
var _theme = require("../utils/theme");
var _excluded = ["label", "hint", "value", "items", "amount", "disabled", "onChange", "min", "max", "theme", "required", "amountLabel", "itemsLabel", "comparisorLabel", "dense", "bordered"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var SelectFormFieldWithQuantity = function SelectFormFieldWithQuantity(_ref) {
  var label = _ref.label,
    hint = _ref.hint,
    value = _ref.value,
    _ref$items = _ref.items,
    items = _ref$items === void 0 ? [] : _ref$items,
    _ref$amount = _ref.amount,
    amount = _ref$amount === void 0 ? 0 : _ref$amount,
    disabled = _ref.disabled,
    onChange = _ref.onChange,
    _ref$min = _ref.min,
    min = _ref$min === void 0 ? 0 : _ref$min,
    max = _ref.max,
    _ref$theme = _ref.theme,
    theme = _ref$theme === void 0 ? _theme.defaultTheme : _ref$theme,
    required = _ref.required,
    _ref$amountLabel = _ref.amountLabel,
    amountLabel = _ref$amountLabel === void 0 ? 'Amount' : _ref$amountLabel,
    _ref$itemsLabel = _ref.itemsLabel,
    itemsLabel = _ref$itemsLabel === void 0 ? '' : _ref$itemsLabel,
    _ref$comparisorLabel = _ref.comparisorLabel,
    comparisorLabel = _ref$comparisorLabel === void 0 ? 'per' : _ref$comparisorLabel,
    _ref$dense = _ref.dense,
    dense = _ref$dense === void 0 ? false : _ref$dense,
    _ref$bordered = _ref.bordered,
    bordered = _ref$bordered === void 0 ? true : _ref$bordered,
    params = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var _useState = (0, _react.useState)(true),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    firstLoading = _useState2[0],
    setFirstLoading = _useState2[1];
  var _useState3 = (0, _react.useState)(amount),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    selectedAmount = _useState4[0],
    setSelectedAmount = _useState4[1];
  var _useState5 = (0, _react.useState)(value !== null && value !== void 0 ? value : items[0]),
    _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
    selectedItem = _useState6[0],
    setSelectedItem = _useState6[1];
  var _useState7 = (0, _react.useState)(false),
    _useState8 = (0, _slicedToArray2["default"])(_useState7, 2),
    isSelected = _useState8[0],
    setSelected = _useState8[1];
  (0, _react.useEffect)(function () {
    if (!firstLoading) {
      onChange(selectedItem, selectedAmount);
    } else {
      setFirstLoading(false);
    }
  }, [selectedItem, selectedAmount]);
  (0, _react.useEffect)(function () {
    if (max && selectedAmount > max) {
      setSelectedAmount(max);
    }
  }, [max]);
  return /*#__PURE__*/_react["default"].createElement(_styledComponents.ThemeProvider, {
    theme: theme
  }, /*#__PURE__*/_react["default"].createElement(_SelectFormFieldWithQuantity.BorderedContainer, (0, _extends2["default"])({
    dense: dense,
    bordered: bordered,
    selected: isSelected
  }, params, {
    disabled: disabled
  }), /*#__PURE__*/_react["default"].createElement(_SelectFormFieldWithQuantity.ContainerRow, null, label && /*#__PURE__*/_react["default"].createElement(_Text.Text, {
    weight: isSelected ? 'bold' : 'normal',
    style: {
      marginRight: '8px',
      marginBottom: '3px',
      color: isSelected ? '#3F51B5' : disabled ? 'rgba(0, 0, 0, 0.38)' : 'rgba(0, 0, 0, 0.6)'
    }
  }, label, required ? '*' : ''), hint && /*#__PURE__*/_react["default"].createElement(_Tooltip.Tooltip, {
    text: hint,
    size: 18,
    placement: "top",
    color: isSelected ? '#3F51B5' : disabled ? 'rgba(0, 0, 0, 0.38)' : 'rgba(0, 0, 0, 0.6)'
  })), /*#__PURE__*/_react["default"].createElement(_SelectFormFieldWithQuantity.ContainerRow, null, /*#__PURE__*/_react["default"].createElement(_SelectFormFieldWithQuantity.ContainerColumn, {
    flex: 2
  }, /*#__PURE__*/_react["default"].createElement(_lib.FormField, {
    min: min,
    max: max,
    label: amountLabel,
    value: selectedAmount,
    disabled: disabled,
    type: "number",
    onChange: function onChange(v) {
      if (v < min) {
        setSelectedAmount(min);
      } else if (max && v > max) {
        setSelectedAmount(max);
      } else {
        setSelectedAmount(v);
      }
    },
    onFocus: function onFocus() {
      return setSelected(true);
    },
    onBlur: function onBlur() {
      return setSelected(false);
    }
  })), comparisorLabel && /*#__PURE__*/_react["default"].createElement(_SelectFormFieldWithQuantity.ContainerColumn, {
    flex: 2
  }, /*#__PURE__*/_react["default"].createElement(_Text.Text, {
    style: {
      margin: '0 8px',
      color: isSelected ? '#3F51B5' : disabled ? 'rgba(0, 0, 0, 0.38)' : 'rgba(0, 0, 0, 0.6)'
    }
  }, comparisorLabel)), /*#__PURE__*/_react["default"].createElement(_SelectFormFieldWithQuantity.ContainerColumn, {
    flex: 8,
    style: {
      width: '100%'
    }
  }, /*#__PURE__*/_react["default"].createElement(_lib.FormField, {
    select: true,
    label: itemsLabel,
    value: selectedItem,
    disabled: disabled,
    items: items,
    onChange: function onChange(v) {
      return setSelectedItem(v);
    },
    onFocus: function onFocus() {
      return setSelected(true);
    },
    onBlur: function onBlur() {
      return setSelected(false);
    }
  })))));
};
var _default = exports["default"] = SelectFormFieldWithQuantity;